import Information16 from '@carbon/icons-react/es/information/16';
import { Tooltip } from 'antd';
import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import {
  Caption01,
  HelperText01,
  ProductiveHeading05,
  SingleLineEllipsis,
} from 'components/styles';

export const SecondaryText = styled.span`
  ${Caption01};
  color: var(--gray-70);
`;

export const HoverableSpan = styled.span`
  cursor: pointer;
`;

export const HoverableSpanWithUnderline = styled(HoverableSpan)`
  text-decoration: underline;
  &:hover {
    color: var(--link-color);
  }
`;

export const MainValue = styled.span<{ color?: string }>`
  ${ProductiveHeading05};
  color: ${({ color }) => color ?? 'var(--gray-100)'};
`;

export const Value = styled.span`
  ${HelperText01};
`;

const InfoIcon = styled(Information16)`
  color: var(--gray-40);
`;

const Title = styled.div`
  ${SingleLineEllipsis};
`;

const Wrapper = styled.div`
  display: flex;
  gap: var(--spacing-02);
`;

export const TitleWithTooltip: FC<{ title: ReactNode; tooltip?: ReactNode }> =
  ({ title, tooltip }) => (
    <Wrapper>
      <Title>{title}</Title>
      {tooltip && (
        <Tooltip title={tooltip}>
          <InfoIcon />
        </Tooltip>
      )}
    </Wrapper>
  );
